import styled from "styled-components";

export const MainContent = styled.div`
  min-height: 200px;
  padding: 50px;
  background: ${props => props.bgColor ? props.bgColor : '#FFFFFF'};
  ${props => props.backgroundImage ? {backgroundImage: props.backgroundImage} : {} }
  background-repeat: no-repeat;
  background-position: right;
  background-position-y: 10px;
  padding-bottom: 50px;

  @media(max-width: 420px) {
    padding: 10px;
  }
`;

export const ErrorContent = styled.div`
  width: 100%;
  min-height: 50px;
`;

export const Content = styled.div`
  padding: ${props => props.toFit ? '0px' : '20px'};
  width: 100%;
  height: 100%;
  background: ${props => props.bgColor ? props.bgColor : '#FFFFFF'};
`;

export const HorizontalArea = styled.div`
  padding: 50px;
  background: ${props => props.color ? props.color : '#FFFFFF'};
  ${props => props.center ? {textAlign: 'center'} : {}};
  @media(max-width: 420px) {
    padding: 10px;
  }
`;

export const GrayCenterArea = styled.div`
  display: grid;
  padding: 20px;
  background: ${props => props.light ? 'rgba(99, 99, 99, 0.1)' : 'rgba(4, 4, 4, 0.2)'};
  border-radius: 6px;
  margin-top: 20px;
`;
